import { Component, ElementRef, EventEmitter, Input, NgModule, Output, Renderer2 } from '@angular/core';
import { CreateControlAccessProvider } from '@wipo/w-angular/shared';
import { FFacetInfoModule } from '@wipo/w-angular/internal';

import { WInputBase } from '@wipo/w-angular/shared';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { WHideEmptyModule } from '@wipo/w-angular/directives';

@Component({
  selector: 'w-input-checkbox-one',
  templateUrl: './w-input-checkbox-one.component.html',
  providers: [CreateControlAccessProvider(WInputCheckboxOneComponent)],
  styles: [`.b-checkmark {border-radius: 3px; top: 60%;}`],
  host: {
    class: 'b-input b-input-checkbox',
    '[class.b-input--is-edit-denied]': 'useReviewMode || disabled',
    '[class.b-input__large]': 'isLarge',
    '[attr.checked]': '!!value ? true : undefined'
  },
  standalone: false
})
/*
@id w-input-checkbox-one
@name w-input-checkbox-one
@status release
@description
*/
export class WInputCheckboxOneComponent extends WInputBase {
  @Input() isReviewMode = false;  // disabled in review mode (legacy settings from JSF)
  @Input() ignoreReviewMode = false; // legacy settings from JSF
  @Input() isLarge: boolean = false; // show as large checkbox (portal style)
  @Input() updateOnChange?: { collection: Record<string, any>[], propertyName: string }; // set property in each array element to current value
  @Output() wChange = new EventEmitter<boolean>();

  public get useReviewMode(): boolean {
    return this.isReviewMode && !this.ignoreReviewMode;
  }
  // tslint:disable-next-line: variable-name
  constructor(protected _renderer: Renderer2, protected _elementRef: ElementRef) { super(); }
  override ngOnInit(): void {
    super.ngOnInit();
  }
  toggle(e: Event) {
    if (!this.disabled) {
      this.value = !this.value;
      this.wChange.next(this.value);
      if (this.updateOnChange) {
        const prop = this.updateOnChange.propertyName;
        this.updateOnChange.collection.forEach(item => {
          item[prop] = this.value;
        });
      }
    }
  }
}
@NgModule({
  imports: [CommonModule, FormsModule, WHideEmptyModule, FFacetInfoModule],
  exports: [WInputCheckboxOneComponent],
  declarations: [WInputCheckboxOneComponent]
})
export class WInputCheckboxOneModule { }
